var appStores = angular.module('app-helpers', []);

appStores.factory('helpers', ['$document', '$http', function ($document, $http) {
    var factory = {};
    var _imagesToPartnumbers = [];

    factory.getGeolocation = function (address, callback) {
        getLatLng(address + ' ' + country, function (lat, lng) {
            if (lat != undefined) {
                if (callback) {
                    callback(lat, lng);
                }
            } else {
                //try to find without country suffix
                getLatLng(address, function (lat, lng) {
                    if (callback) {
                        callback(lat, lng);
                    }
                })
            }
        })
    }

    var browserLocation;
    var gettingBrowserLocation = false;

    var check = function (callback) {
        if (gettingBrowserLocation == false) {
            // run when condition is met
            if (browserLocation != undefined) {
                if (callback) {
                    callback(browserLocation.lat, browserLocation.lng, browserLocation.dealercity);
                }
            } else {
                return true;
            }
        }
        else {
            console.log('wait for browser location acceptance');
            setTimeout(function () {
                check(callback);
            }, 500); // check again in a second
        }
    }

    var browserLocationSuccess = function (position, callback) {
        var latlng = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);
        var geocoder = new google.maps.Geocoder();
        geocoder.geocode({ latLng: latlng }, function (results, status) {
            var dealercity = '';
            if (status == google.maps.GeocoderStatus.OK) {
                if (results[1]) {
                    var arrAddress = results;
                    console.log(results);
                    $.each(arrAddress, function (i, address_component) {
                        if (address_component.types[0] == "locality") {
                            console.log("dealercity: " + address_component.address_components[0].long_name);
                            dealercity = address_component.address_components[0].long_name;
                        }
                    });
                    if (dealercity.length == 0) {
                        //try to find by administrative_area_level_4
                        $.each(arrAddress, function (i, address_component) {
                            if (address_component.types[0] == "administrative_area_level_4") {
                                console.log("dealercity: " + address_component.address_components[0].long_name);
                                dealercity = address_component.address_components[0].long_name;
                            }
                        });
                    }
                    if (dealercity.length == 0) {
                        //try to find by postal_town
                        $.each(arrAddress, function (i, address_component) {
                            if (address_component.types[0] == "postal_town") {
                                console.log("dealercity: " + address_component.address_components[0].long_name);
                                dealercity = address_component.address_components[0].long_name;
                            }
                        });
                    }
                } else {
                    dealercity = lblNoLocationFound;
                }
            } else {
                //Raygun.send("Google Maps Geocoder exception. Status: " + status);
                dealercity = "Geocoder failed due to: " + status;
            }

            browserLocation = { lat: position.coords.latitude, lng: position.coords.longitude, dealercity: dealercity };
            gettingBrowserLocation = false;

            if (callback && dealercity.length > 0) {
                callback(position.coords.latitude, position.coords.longitude, dealercity);
            }
        });
    }

    factory.getBrowserLocation = function (callback, lookup) {
        if (lookup == undefined || lookup == null || lookup == true) {

            if (check(callback)) {
                //wait to try again
                if (navigator.geolocation) {
                    gettingBrowserLocation = true;
                    navigator.geolocation.getCurrentPosition(function (position) {
                        browserLocationSuccess(position, callback);
                    }, function (error) {
                        browserLocation = { lat: window.defaultLatitude, lng: window.defaultLongitude, dealercity: window.defaultCity };
                        gettingBrowserLocation = false;
                        callback(window.defaultLatitude, window.defaultLongitude, window.defaultCity);
                        //if (error.code == error.PERMISSION_DENIED) {
                        //    // pop up dialog asking for location
                        //}
                    }, { timeout: 5000 });//5sec
                }
            }
        } else {
            callback();
        }
    }

    //factory.getBrowserLocation = function (callback, lookup) {
    //    if (lookup == undefined || lookup == null || lookup == true) {
    //        if (navigator.geolocation) {
    //            navigator.geolocation.getCurrentPosition(function (position) {

    //                var latlng = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);
    //                //latlng = new google.maps.LatLng(52.706926, -1.093812);
    //                var geocoder = new google.maps.Geocoder();
    //                geocoder.geocode({ latLng: latlng }, function (results, status) {
    //                    var dealercity = '';
    //                    if (status == google.maps.GeocoderStatus.OK) {
    //                        if (results[1]) {
    //                            var arrAddress = results;
    //                            console.log(results);
    //                            $.each(arrAddress, function (i, address_component) {
    //                                if (address_component.types[0] == "locality") {
    //                                    console.log("dealercity: " + address_component.address_components[0].long_name);
    //                                    dealercity = address_component.address_components[0].long_name;
    //                                }
    //                            });
    //                            if (dealercity.length == 0) {
    //                                //try to find by administrative_area_level_4
    //                                $.each(arrAddress, function (i, address_component) {
    //                                    if (address_component.types[0] == "administrative_area_level_4") {
    //                                        console.log("dealercity: " + address_component.address_components[0].long_name);
    //                                        dealercity = address_component.address_components[0].long_name;
    //                                    }
    //                                });
    //                            }
    //                            if (dealercity.length == 0) {
    //                                //try to find by postal_town
    //                                $.each(arrAddress, function (i, address_component) {
    //                                    if (address_component.types[0] == "postal_town") {
    //                                        console.log("dealercity: " + address_component.address_components[0].long_name);
    //                                        dealercity = address_component.address_components[0].long_name;
    //                                    }
    //                                });
    //                            }
    //                        } else {
    //                            dealercity = lblNoLocationFound;
    //                        }
    //                    } else {
    //                        //Raygun.send("Google Maps Geocoder exception. Status: " + status);
    //                        dealercity = "Geocoder failed due to: " + status;
    //                    }

    //                    if (callback && dealercity.length > 0) {
    //                        callback(position.coords.latitude, position.coords.longitude, dealercity);
    //                    }
    //                });
    //            }, function (error) {
    //                callback(window.defaultLatitude, window.defaultLongitude);
    //                //if (error.code == error.PERMISSION_DENIED) {
    //                //    // pop up dialog asking for location
    //                //}
    //            }, { timeout: 5000 });//5sec
    //        }
    //    } else {
    //        callback();
    //    }
    //}

    factory.__envMobile = undefined;
    factory.isMobile = function () {
        if (factory.__envMobile !== undefined)
            return factory.__envMobile;

        var envs = ['xs', 'sm', 'md', 'lg'];

        var el = angular.element('<div>');
        $document.find('body').append(el);

        for (var i = envs.length - 1; i >= 0; i--) {
            var env = envs[i];

            el.addClass('hidden-' + env);
            if (el.is(':hidden')) {
                el.remove();
                factory.__envMobile = env === 'xs';

                return factory.__envMobile;
            }
        }
    };

    factory.setImagesToPartnumbers = function (imagesToPartnumbers) {
        _imagesToPartnumbers = imagesToPartnumbers;
    };

    factory.getImagesToPartnumbers = function () {
        return _imagesToPartnumbers;
    };

    factory.validateAddress = function (street, postalcode, city, _callbackKeep, _callbackUpdate) {
        var url = '/' + window.culture + '/validate-address'
        $http({
            method: 'POST',
            url: url,
            cache: false,
            withCredentials: true,
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            transformRequest: function (obj) {
                //Deze transformatie is nodig icm Content-Type anders krijg je een 404 preflight error (http://stackoverflow.com/questions/24710503/how-do-i-post-urlencoded-form-data-with-http-in-angularjs)
                var str = [];
                for (var p in obj)
                    str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
                return str.join("&");
            },
            data: { Street: street, PostalCode: postalcode, City: city },
        }).then(function (res) {
            if (res.data != null) {
                if (res.data.Result == false) {
                    $('#street_filled').text(street);
                    $('#postalcode_filled').text(postalcode);
                    $('#city_filled').text(city);
                    $('#street_suggestion').text(res.data.Address.Street + ' ' + res.data.Address.BuildingNumber);
                    $('#postalcode_suggestion').text(res.data.Address.PostalCode);
                    $('#city_suggestion').text(res.data.Address.City);
                    $('#AddressValidateFailedModal').modal('show');

                    //bind callback to modal buttons
                    $('#btnAddressSearchKeep').on('click', function () {
                        if (_callbackKeep) {
                            _callbackKeep();
                        }
                    });
                    $('#btnAddressSearchUpdate').on('click', function () {

                        if (_callbackUpdate) {
                            _callbackUpdate(res.data.Address);
                        }
                    });
                    return;
                }
            }
            if (_callbackKeep) {
                _callbackKeep();
            }
        });
    }

    return factory;
}]);